import { cn } from '@/lib/utils';

interface ToggleChipProps {
  id: string;
  label: string;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export default function ToggleChip({
  id,
  label,
  selected,
  onClick,
  disabled,
}: ToggleChipProps) {
  return (
    <button
      id={id}
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'px-3 py-1.5 rounded-md text-xs border transition-colors',
        selected
          ? 'border-primary bg-primary text-primary-foreground'
          : 'border-border hover:bg-muted',
        disabled && 'opacity-50 cursor-not-allowed',
      )}
      aria-pressed={selected}
    >
      {label}
    </button>
  );
}
